import React from "react"

import { Container, Col, Row } from "react-bootstrap"

import CharacteristicsCard from "@/homeOwners/characteristicsCard"

function CharacteristicsStrip(props) {
    return (
        <Container fluid="md" className="p-0 mt-4">
            <Row className="mx-0 d-none d-sm-flex">
                <Col xs={12} sm={6} xl={3} className="p-0 pe-2 pe-xl-4">
                    <CharacteristicsCard
                        icon="knowledge-icon.svg"
                        alt="Hands held out with a brain to signify knowledge"
                        title="Extensive local knowledge"
                        delay={0}
                        description={props.description1}
                    />
                </Col>
                <Col xs={12} sm={6} xl={3} className="p-0 ps-2 ps-xl-2 pe-xl-3">
                    <CharacteristicsCard
                        icon="advice-icon.svg"
                        alt="Two people communicating, with one offering the other advice"
                        title="Expert advice"
                        delay={500}
                        description={props.description2}
                    />
                </Col>
                <div
                    className="d-none d-sm-block d-xl-none"
                    style={{ height: "1.5rem" }}
                ></div>

                <Col
                    xs={12}
                    sm={6}
                    xl={3}
                    className="p-0 pe-2 pe-xl-2 ps-xl-3 d-none d-xl-flex"
                >
                    <CharacteristicsCard
                        icon="standards-icon.svg"
                        alt="A ribbon with a star to signify award winning standards"
                        title="Professional standards"
                        delay={1000}
                        description={props.description3}
                    />
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    xl={3}
                    className="p-0 pe-2 pe-xl-2 ps-xl-3 d-xl-none"
                >
                    <CharacteristicsCard
                        icon="standards-icon.svg"
                        alt="A ribbon with a star to signify award winning standards"
                        title="Professional standards"
                        delay={0}
                        description={props.description3}
                    />
                </Col>

                <Col
                    xs={12}
                    sm={6}
                    xl={3}
                    className="p-0 ps-2 ps-xl-4 d-none d-xl-flex"
                >
                    <CharacteristicsCard
                        icon="respect-icon.svg"
                        alt="A heart icon where each side of the heart is represented shaking hands"
                        title="Communication & respect"
                        delay={1500}
                        description={props.description4}
                    />
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    xl={3}
                    className="p-0 ps-2 ps-xl-4 d-xl-none"
                >
                    <CharacteristicsCard
                        icon="respect-icon.svg"
                        alt="A heart icon where each side of the heart is represented shaking hands"
                        title="Communication & respect"
                        delay={500}
                        description={props.description4}
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default CharacteristicsStrip
